import { FC, ReactNode, useEffect, useState } from "react";
import { StyledButton } from "./styles";
import { LoadingOutlined } from "@ant-design/icons";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";
import {
  BUTTON_HEIGHT_LARGE,
  DisplaySize,
  FONT_SIZE,
  MENU_COLORS,
  UNSAVED_CHANGES_WARNING_MESSAGE,
} from "@lhd/constants";

interface ButtonBackProps {
  onClick?: () => void;
  height?: number;
  displaySize?: DisplaySize;
  name?: string;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  icon?: ReactNode;
  iconRight?: ReactNode;
  style?: React.CSSProperties;
  type?: string;
  isFull?: boolean;
  confirmContent?: ReactNode;
  confirmOkText?: string;
  confirmCancelText?: string;
  showConfirm?: boolean;
}

const ButtonBack: FC<ButtonBackProps> = ({
  onClick,
  height,
  displaySize,
  name,
  className,
  style,
  disabled,
  icon,
  iconRight,
  loading,
  type = "cancel-back",
  isFull,
  confirmContent = UNSAVED_CHANGES_WARNING_MESSAGE,
  confirmOkText,
  confirmCancelText,
  showConfirm = false,
}) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  useEffect(() => {
    if (!showConfirm) setIsConfirmOpen(false);
  }, [showConfirm]);

  const handleConfirm = () => {
    if (disabled || loading) return;
    setIsConfirmOpen(false);
    onClick?.();
  };

  return (
    <>
      <StyledButton isFull={isFull}>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            if (showConfirm) {
              setIsConfirmOpen(true);
            } else {
              onClick?.();
            }
          }}
          disabled={!!disabled || !!loading}
          className={`button-back-common ${!disabled ? type : ""} ${
            className || ""
          } ${loading ? "btn-loading" : ""}`}
          style={{
            height: displaySize
              ? BUTTON_HEIGHT_LARGE[displaySize]
              : height || 24,
            ...(displaySize && { fontSize: FONT_SIZE[displaySize] }),
            ...style,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className="button-content">
            {loading && <LoadingOutlined className="button-loading" />}
            {icon && <div className="button-icon">{icon}</div>}
            <span className="button-text">{name || "戻る"}</span>
            {iconRight && <div className="button-icon">{iconRight}</div>}
          </div>
        </button>
      </StyledButton>
      {showConfirm && (
        <ModalConfirm
          isOpen={isConfirmOpen}
          content={confirmContent}
          isSubmitting={loading}
          onCancel={() => setIsConfirmOpen(false)}
          onOk={handleConfirm}
          okText={confirmOkText}
          cancelText={confirmCancelText}
        />
      )}
    </>
  );
};

export default ButtonBack;
